import gql from 'graphql-tag'

// ** Mutations **
export const Authenticate = gql`
    mutation Authenticate($input: AuthenticateInput!) {
        authenticate(input: $input) {           
            email 
            key
            expireAt
            landingPage
        }
    }
`
export const Verify = gql`
    mutation Verify($input: VerifyInput!) {
        verify(input: $input) {
            access_token
            user_data {
                id
                first_name
                last_name
                email
                role
                landing_page
                avatar_url
                suppliers_id
            }
            user_abilities {
                action
                subject
            }
        }
    }
`
export const Logout = gql`
    mutation Logout {
        logout {
            status
            message
        }
    }
`
export const LogoutOtherDevices = gql`
    mutation LogoutOtherDevices {
        logoutOtherDevices {
            status
            message
        }
    }
`
export const ForgotPassword = gql`
    mutation ForgotPassword($input: ForgotPasswordInput!) {
        forgotPassword(input: $input) {
            status
            message
        }
    }
`
export const ResetPassword = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
        resetPassword(input: $input) {
            status
            message
        }
    }
`
export const UpdateAccountInformation = gql`
    mutation UpdateAccountInformation($input: UpdateAccountInformationInput!) {
        updateAccountInformation(input: $input) {
            id
            first_name
            last_name                
            email
            role
            landing_page
            avatar_url
            suppliers_id
        }
    }
`
export const DeactivateAccount = gql`
    mutation DeactivateAccount {
        deactivateAccount {
            status
            message
        }
    }
`
export const UpdatePassword = gql`
    mutation UpdatePassword($input: UpdatePasswordInput!) {
        updatePassword(input: $input) {
            status
        }
    }
`
export const UpdateBookmark = gql`
    mutation UpdateBookmark($input: UpdateBookmarkInput!) {
        updateBookmark(input: $input) {
            status
            message
        }
    }
`
export const UpdateUserNotification = gql`
    mutation UpdateUserNotification($input: UpdateUserNotificationInput!) {
        updateUserNotification(input: $input) {
            status
            message
        }
    }
`

// ** Queries **
export const Me = gql`
    query Me {
        me {
            id
            first_name
            last_name
            email
            avatar_url
            language
            bookmarks {
                id
                title
                icon
                target
                link
                pivot {
                    is_bookmarked
                }
            }
            suggestions {
                id
                title
                icon
                target
                link
                pivot {
                    is_bookmarked
                }
            }
            search {
                groupTitle
                searchLimit
                data {
                    id
                    title
                    icon
                    target
                    link
                    pivot {
                        is_bookmarked
                    }
                }
            }
            notificationModules {
                id
                notificationModule {
                    module_name
                }
                email_notify
                app_notify
            }
        }
    }
`
export const AuthenticationLog = gql`
    query AuthenticationLog {
        authenticationLog {
            platform
            browser
            ip_address
            login_at
        }
    }
`
